import * as React from "react"

import { cn } from "@/lib/utils"

interface InputProps extends React.ComponentProps<"input"> {
  name?: string; // Tornar explícito para destacar a importância
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, name, id, autoComplete, ...props }, ref) => {
    // Garantir que sempre temos um name ou id
    const inputName = name || id || `input-${Math.random().toString(36).substring(2, 9)}`;
    // Definir autoComplete se não estiver definido
    const inputAutoComplete = autoComplete || "off";
    
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        name={inputName}
        id={id || inputName}
        autoComplete={inputAutoComplete}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
